import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'
import { useAlert } from '../../../ui/Alert'
import config from '../../../constants'

const title = 'Meters'
const headers = {
  icon: 'feather icon-droplet',
  title: title,
  description: 'track and manage all meters information',
}

export default function MeterPage() {
  const { push } = useAlert()

  async function updateCours(el, value, callback) {
    el = {
      ...el,
      status: value,
      zone: el.zone.id,
      client: el.client.id,
    }
    let res = await resources.meter
      .update(el.id, el)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      callback()
      push({
        success: true,
      })
    } else if (res.status === 403) {
      push({
        error: true,
        message: config.app.error,
      })
    }
  }

  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'serial number',
            field: 'numero_de_serie',
          },
          { label: 'HWD_ID', field: 'code' },
          {
            label: 'Meter name',
            field: 'meter_name',
          },
          {
            label: 'Ownership',
            field: 'ownership',
          },
          {
            label: 'Zone',
            field: 'group',
            renderStyle: (el) => {
              if (el.group) {
                return (
                  (el?.group?.name ?? '') +
                  ' | ' +
                  el?.group?.zone?.zone +
                  ' | ' +
                  el?.group?.zone?.location
                )
              }
            },
          },
          {
            label: 'Client',
            field: 'zone',
            renderStyle: (el) => el?.client?.name,
          },
          {
            label: 'Status',
            field: 'status',
            renderStyle: (data) => {
              return (
                <p>
                  {data.status === 1 && (
                    <label className="form-label label label-success">active</label>
                  )}
                  {data.status === 2 && (
                    <label className="form-label label label-danger">inactive</label>
                  )}
                </p>
              )
            },
          },
        ]}
        resource={resources.meter}
        title={title}
        link="/meters/meters"
        action={(data, callback) => {
          return (
            <>
              {data.status === 1 ? (
                <li onClick={() => updateCours(data, 2, callback)}>
                  <span
                    className="dropdown-item"
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <i className="feather icon-lock"></i> deactivate
                  </span>
                </li>
              ) : (
                <li onClick={() => updateCours(data, 1, callback)}>
                  <span
                    className="dropdown-item"
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <i className="feather icon-unlock"></i> activate
                  </span>
                </li>
              )}
            </>
          )
        }}
      />
    </MainPage>
  )
}
